module.exports = __webpack_public_path__ + "static/media/autosign-off.61457cf3.svg";